import {createReducer} from '@reduxjs/toolkit'
import {getCheckoutOptions} from '../actions/checkout-options'
import {CheckoutOptionsState} from '../types/state'

const defaultState: CheckoutOptionsState = {
  loaded: false,
  options: {
    premiumServices: true,
    paymentMethodConfigured: true,
    acceptCoupons: true,
    acceptGiftCards: true,
  },
}

export const checkoutOptions = createReducer(defaultState, builder => {
  builder.addCase(getCheckoutOptions.fulfilled, (state, action) => {
    state.options = {...state.options, ...action.payload}
    state.loaded = true
  })
})
